module.exports = __webpack_public_path__ + "img/7239e61912a22c7546e4ce704c86a5d3.png";